import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

// Öffentliche Seiten (PaymentSuccess, NotFound, SessionInvite, …): fest einbinden,
// damit Übersetzungen nicht von einem separaten /locales/…-Fetch abhängen (PWA/SW, Redirects).
import pagesDe from "../../locales/de/pages.json";
import pagesEn from "../../locales/en/pages.json";

i18n
  .use(Backend) // Dynamisches Laden via Fetch API
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Mit Backend nur in Kombination mit true, sonst behandelt i18next alle NS als „geladen“
    // und lädt common/landing/… nicht mehr nach (Rohschlüssel in der ganzen App).
    partialBundledLanguages: true,
    resources: {
      de: { pages: pagesDe },
      en: { pages: pagesEn },
    },
    // Query ändert sich bei jedem Produktions-Build (Datum + SHA): Nutzer brauchen keinen manuellen Cache-Clear.
    // Ohne SW-Anpassung: neue JS-Bundles referenzieren neue URLs → SW/HTTP-Cache treffen alte locale-Dateien nicht.
    backend: {
      loadPath: `${import.meta.env.BASE_URL || ""}locales/{{lng}}/{{ns}}.json?v=${encodeURIComponent(
        [
          import.meta.env.VITE_APP_VERSION,
          import.meta.env.VITE_BUILD_DATE,
          import.meta.env.VITE_GIT_SHA,
        ]
          .filter((x) => x != null && String(x).trim() !== "")
          .join("-") || "dev"
      )}`,
    },
    defaultNS: "common",
    // Verhindert doppeltes Initial-Laden beider Sprachen.
    // Für de kein Fallback, für andere Sprachen ggf. auf de zurückfallen.
    fallbackLng: (code) => {
      if (code === "de") return [];
      return ["de"];
    },
    // Nur die aktuelle Sprache laden (z.B. de oder en), nicht zusätzliche Varianten.
    load: "currentOnly",
    // Wichtig: useSuspense sorgt dafür, dass useTranslation suspendiert, bis
    // der Namespace geladen ist – sonst werden Keys statt Übersetzungen angezeigt
    react: {
      useSuspense: true,
    },
    supportedLngs: ["de", "en"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      caches: ["localStorage"],
      lookupQuerystring: "lng",
      lookupLocalStorage: "i18nextLng",
      // Konvertiere Browser-Sprache zu unterstützter Sprache
      // Deutsch → 'de', alles andere → 'en'
      convertDetectedLanguage: (lng: string) => {
        // Wenn bereits 'de' oder 'en', direkt zurückgeben
        if (lng === "de" || lng === "en") {
          return lng;
        }
        // Wenn Browser-Sprache mit 'de' beginnt (z.B. 'de-DE', 'de-AT'), dann 'de'
        if (lng.startsWith("de")) {
          return "de";
        }
        // Alle anderen Sprachen → 'en' (Fallback auf Englisch)
        return "en";
      },
    },
    // Performance: Initial nur Public-Startpfad laden.
    // Weitere Namespaces werden bei useTranslation("<ns>") on-demand nachgeladen.
    // "social" wird auf Landing sofort benötigt (Social-Links, ggf. Session-Teaser).
    // "pages" wird für PaymentSuccess, NotFound etc. benötigt (öffentliche Seiten).
    ns: ["common", "landing", "booking", "social", "pages"],
  });

export default i18n;
